import { Navigate, Outlet } from 'react-router-dom'
import {isUserLoggedIn, getUserType } from '../config/userSession';
const ProtectedSuperAdminRoutes = () => {
return (
    isUserLoggedIn() && getUserType() === 'SuperAdmin' ? <Outlet/> : <Navigate to='/login'/>
  )
}
export default ProtectedSuperAdminRoutes;